import React from "react"
import { Card } from "reactstrap"
import Countdown from "react-countdown"

import "./CountdownTimer.scss"

// custom function to format Countdown component
const renderer = ({ days, hours, minutes, seconds }) => {
    return (
        <div className="countdown-wrap">
            <div>Days: {days}</div>
            <div>Hours: {hours}</div>
            <div>Minutes: {minutes}</div>
            <div>Seconds: {seconds}</div>
        </div>
    )
}

const CountdownTimer = ({ startTime }) => {
    // 1675227600000 == Wed Feb 1, 2023 12AM EST
    // 1675263600000 == Wed Feb 1, 2023 10AM EST

    return (
        <div className="countdown-timer">
            <Card className="countdown-card">
                <div className="start-title">Sale Begins February 1, 10AM EST</div>
                <Countdown date={startTime} renderer={renderer} />
            </Card>
        </div>
    )
}

export default CountdownTimer
